import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { IName } from '../../blocks/names/name.component';
import { IIdentity } from '../../blocks/identity_type/identity_type.component';
import { IAddress } from '../../hospitalSetup/address/address.component';
import { CONFIG } from '../../shared/config';
import { TherapeuticCards } from '../../registeration/contracts';
import { GenModuleSettingService } from '../../shared/gen-module-setting.service';
let callCenterReservation = CONFIG.baseUrls.emergencyReservation;
let stockTransUrl = CONFIG.baseUrls.StockTrans;
let callCenter = CONFIG.baseUrls.callCenter;
export interface TotalData {
  callMainData: CallBeneficiary[];
  therapeuticCards: TherapeuticCards;
  callData: CallData;
  mark_Leads: Mark_Leads;
}

export interface ErPatient extends CallBeneficiary {
  name: IName;
  address: IAddress;
  identity: IIdentity;
  therapeuticCards: TherapeuticCards;
  dateHijriNgb: any;
  birthDateNgb: any;
  mortalityDateNgb: any;
  serviceCode: number;
  patExpectedFlag: number;
  expectedDate: Date;
  doctorID: number;
  cost: number;
  leadType: number;
  mobile: number;
  familyMobile: string;

}

export interface MsgTemplate {
  moduleId: number
  empId: number
  specialityId: number
  reservationDate: Date
  fieldName: string
}

export interface Mark_Leads {
  serial: number;
  visitSerial: number;
  ccCallBeneficiaryCode: number;
  doctorID: number;
  leadType: number;
  futureCallExpectedAfterDays: number;
  serviceID: number;
  serviceName: string;
  expectedDate: Date;
  cost: number;
  discount: number;
  finalCost: number;
  notes: string;
  discountApproval: number;
  discountType?: number;
  operationStatus: number;
  dealStatus: number;
}

export interface CallData {
  serial: number;
  phoneNumber: string;
  familyPhoneNumber: string;
  address: string;
  callResult: string;
  notes: number;
  branchId: number;
  birthDateNgb: Date;
  callerName: string;
  nationalityId: string;
  callReason: number;
  specialization: number;
  branchAddress: number;
  regPatServiceSerial?: number;
  regPatMedicalStepsSerial?: number;
  callStart: Date;
  callEnd: Date;
  expectedStartTime?: Date,
  expectedEndTime?: Date,
  dateOnly?: string,
  genDaysNameAr?: string,
  genDaysNameEn?: string,
  startTimeOnly?: string,
  endTimeOnly?: string,
  cCCallClassificationCode?: number;
  minutesPerSlot?: number
  reservationDate?: Date;
  arrivalResult: number;
  serviceCode: string;
  visitSerial: number;
  patCode: number;
  cCCallBeneficiarySerial: number
  dataStatus: number;
  docNotesOnCall: string;
  docId: number;
  anesthesiologist: number;
  classificationCode: number;
  callTypeFalg: number;
  secoundMobile: string;
  cancelReason?: number;
  cancelNotes: string;
  reservationType: number;
  callmethod?: number;
  callSort: number;
  entityType?: number;
  clinicCode?: number;
  device?: number;
  bookedByFlag?: number;
  confirmationReservationFlag?: number;
  complaintsDesc?: number;
  medicalCompliant?:number;
  complaints?: string
  linkedCallSerial?:number;

}
export interface msgTemplate {
  templateType?: number
}
export interface CallBeneficiary {
  code: number;
  fullnameAr: string;
  fullnameEn: string;
  mobile: number;
  familyMobile: string;
  mobile2: number;
  mobile3: number;
  fullAddressAr: string;
  fullAddressEn: string;
  nationalityId: number;
  gender: number;
  birthDate: Date;



  fnameAr: string;
  snameAr: string;
  tnameAr: string;
  lnameAr: string;
  fnameEn: string;
  snameEn: string;
  tnameEn: string;
  lnameEn: string;
  religionId: number;
  birthPlace: string;
  countryCode: number;
  govCode: number;
  cityCode: number;
  villageCode: number;
  identityType: number;
  identityValue: string;
  bloodGroup: number;
  rhValue: number;
  homePhone: string;
  maritalStatus: number;
  mailAddress: string;
  titleCode: number;
  regDate: Date;
  regUser: number;
  updateDate: Date;
  updateUser: number;
  searchDescAr: string;
  searchDescEn: string;
  approxAge: number;
  hasPreviousDonation?: boolean;
  howToReachUs: number;
  parentId:number;
  contractId: number;
  offset: number;
  pageSize: number;
}

@Injectable()
export class CallCenterReservationService {
  constructor(
    private httpGeneralService: HttpGeneralService, private _MS: GenModuleSettingService) { }

  addCallerData(patient: TotalData) {
    return this.httpGeneralService.add<TotalData>(patient, `${callCenterReservation}/AddCallerData`);
  }
  addPrivateDoctorCallerData(patient: CallData) {
    return this.httpGeneralService.add<CallData>(patient, `${callCenterReservation}/AddCallerData`);
  }
  addSecoundPhoneNumber(patient: TotalData) {
    return this.httpGeneralService.add<TotalData>(patient, `${callCenterReservation}/AddSecoundPhoneNumber`);
  }

  updateCallerData(patient: TotalData) {
    return this.httpGeneralService.add<TotalData>(patient, `${callCenterReservation}/updateCallerData`);
  }

  updatePatientAppointment(patient: TotalData) {
    return this.httpGeneralService.add<TotalData>(patient, `${callCenterReservation}/updatePatientAppointment`);
  }
  /**************17-8-2024************* */

  getStockModuleSettings(parms: any) {
    return this._MS.getStockModuleSettings(parms);
  }


  getLastPatientForEdit(id: number) {
    return this.httpGeneralService.get(id, `${callCenterReservation}/getLastPatientData`);
  }

  getPatientMobile(parms: any) {
    return this.httpGeneralService.search(parms, `${callCenterReservation}/getPatientMobile`);

  }
  checkCallDataPhoneNumber(parms: any) {
    return this.httpGeneralService.search(parms, `${callCenterReservation}/checkCallDataPhoneNumber`);

  }
  getStock(parms: any) {
    return this._MS.getStockModuleSettings(parms);
  }

  // getMsgTemplate(getMsgTemplate: MsgTemplate) {
  //   getMsgTemplate.moduleId = 10123
  //   return this.httpGeneralService.add(getMsgTemplate, `${callCenterReservation}/SendTemplateMsg`);
  // }

}


